module.exports = __webpack_public_path__ + "static/media/hazy.b32216d9.png";